import { Locale } from '@ps-smart-cp/ppfw-client';

const resdDprecApplyClassNameConfig = {
  execute: new Map([[Locale.ja, '行う']]),
  doNotExecute: new Map([[Locale.ja, '行わない']]),
} satisfies Record<string, Map<Locale, string>>;

export { resdDprecApplyClassNameConfig };
